import { formatRepositoryRef, type HandoverDocument } from "@baton/contracts";

const SECTIONS: ReadonlyArray<{ key: "done" | "todo" | "verify" | "ideas"; label: string }> = [
  { key: "done", label: "Done" },
  { key: "todo", label: "To do" },
  { key: "verify", label: "Verify" },
  { key: "ideas", label: "Ideas" },
];

/** A decrypted handover inside a chat bubble: where the work lives, then the four lists and the notes. */
export function HandoverBlock({ document }: { document: HandoverDocument }) {
  const where = [document.project?.name, ...document.repositories.map(formatRepositoryRef)].filter((part): part is string => Boolean(part));
  const sections = SECTIONS.filter((section) => document[section.key].length > 0);
  return <section className="chat-handover" data-testid="handover-block">
    <header className="chat-handover-head">
      <strong>Handover</strong>
      {where.length > 0 && <span>{where.join(" · ")}</span>}
    </header>
    {sections.map((section) => <div key={section.key} className="chat-handover-section">
      <p className="chat-handover-label">{section.label}</p>
      <ul>{document[section.key].map((item, index) => <li key={`${index}:${item}`}>{item}</li>)}</ul>
    </div>)}
    {document.notes && <p className="chat-handover-notes">{document.notes}</p>}
  </section>;
}
